import { TFunction } from "i18next";
import * as Yup from "yup";
import { ReportExecutionModeEnum, ReportFrequencyTypeEnum } from "../types/enums";

export const reportDefinitionFormSchema = (t: TFunction) =>
    Yup.object().shape({
        title: Yup.string()
            .required(t("common:form.requiredFieldForm")),

    status: Yup
        .number()
        .required(t("common:form.requiredFieldForm")),

    executionMode: Yup
        .number()
        .required(t("common:form.requiredFieldForm")),

    frequencyType: Yup
        .number()
        .when('executionMode', {
            is: ReportExecutionModeEnum.Scheduled,
            then: (schema) => schema.required(t("common:form.requiredFieldForm")),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),

    contentDeliveryType: Yup
        .number()
        .required(t("common:form.requiredFieldForm")),

    // ---------- BetweenDates ----------
    startDate: Yup
        .date()
        .when('frequencyType', {
            is: ReportFrequencyTypeEnum.BetweenDates,
            then: (schema) => schema.required(t("common:form.requiredFieldForm")),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),

    endDate: Yup
        .date()
        .when('frequencyType', {
            is: ReportFrequencyTypeEnum.BetweenDates,
            then: (schema) =>
                schema
                    .required(t("common:form.requiredFieldForm"))
                    .min(Yup.ref('startDate'), t("common:form.messageErrorFinishDateBeforeStartDate")),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),

    // ---------- Monthly ----------
    month: Yup
        .number()
        .when('frequencyType', {
            is: ReportFrequencyTypeEnum.Monthly,
            then: (schema) => schema.required(t("common:form.requiredFieldForm")),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),

    // ---------- Quarterly ----------
    quarter: Yup
        .number()
        .when('frequencyType', {
            is: ReportFrequencyTypeEnum.Quarterly,
            then: (schema) => schema.required(t("common:form.requiredFieldForm")),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),

    // ---------- Biannually ----------
    semester: Yup
        .number()
        .when('frequencyType', {
            is: ReportFrequencyTypeEnum.Biannually,
            then: (schema) => schema.required(t("common:form.requiredFieldForm")),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),

    // ---------- Year (Monthly / Quarterly / Biannually / Annually) ----------
    year: Yup
        .number()
        .when(['frequencyType', 'isPeriodical'], {
            is: (frequencyType: number, isPeriodical: boolean) =>
                frequencyType === ReportFrequencyTypeEnum.Annually ||
                    ((frequencyType === ReportFrequencyTypeEnum.Monthly ||
                        frequencyType === ReportFrequencyTypeEnum.Quarterly ||
                        frequencyType === ReportFrequencyTypeEnum.Biannually) &&
                        isPeriodical === false
                    ),
            then: (schema) => schema.required(t("common:form.requiredFieldForm")),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),

    sendingDate: Yup
        .date()
        .required(t("common:form.requiredFieldForm")),

    // selectedKPIs: Yup
    //     .array()
    //     .of(yup.number().required())
    //     .default([]),

    // selectedUsers: Yup
    //     .array()
    //     .of(yup.number().required())
    //     .default([]),

    // selectedFunctionalAreas: Yup
    //     .array()
    //     .of(Yup.number().required())
    //     .default([]),

    // selectedServices: Yup
    //     .array()
    //     .of(Yup.number().required())
    //     .default([]),

    // selectedRequestTypes: Yup
    //     .array()
    //     .of(Yup.number().required())
    //     .default([]),

    // selectedOrganizationalStructures: Yup
    //     .array()
    //     .of(Yup.number().required())
    //     .default([]),
});


